import React from 'react';

export default function PageLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100">
      <div className="max-w-2xl mx-auto px-6 py-10">
        <a
          href="/"
          className="text-sm text-blue-600 hover:underline dark:text-blue-400"
        >
          ← Back to SMPW Scheduler
        </a>
        <h1 className="mt-6 text-3xl font-semibold font-display tracking-tight">{title}</h1>
        <div className="mt-8 page-content">
          {children}
        </div>
      </div>
    </div>
  );
}
